import { CloudDownloadError } from './CloudDownloadError'
import type { PickedCloudFile } from './types'

// Shared with the import picker page (militao/import-picker), so it imports nothing that pulls in Sentry, PostHog or app config.

const PDF_SIGNATURE = '%PDF-'
// PDF readers accept junk before the header as long as it starts within the first 1,024 bytes.
const PDF_HEADER_SEARCH_BYTES = 1_024

const hasPdfHeader = async (blob: Blob) => {
  const firstBytes = await blob.slice(0, PDF_HEADER_SEARCH_BYTES).text()
  return firstBytes.includes(PDF_SIGNATURE)
}

// A cut-off PDF can still open, so the byte count must match what the provider listed.
const verifyPdfBytes = async (blob: Blob, expectedSize: number) => {
  if (!(await hasPdfHeader(blob))) {
    throw new CloudDownloadError('not-pdf')
  }
  if (blob.size !== expectedSize) throw new CloudDownloadError('size-mismatch')
}

export const downloadVerifiedPdf = async (picked: PickedCloudFile) => {
  const blob = await picked.download()
  await verifyPdfBytes(blob, picked.size)
  return blob
}
